import { c as _c } from "react/compiler-runtime";
import { PrimaryButton } from '@systemeio/ui';
import { EmailPreviewModal } from 'modules/mailing/email-statistics/components/email-preview-modal';
import React, { useState } from 'react';
import { EmailInterface } from 'shared/components/dashboard-mail-editor/types/email-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface EmailPreviewProps extends Partial<HTMLDivElement> {
  email?: EmailInterface;
}
export const EmailPreview = t0 => {
  const $ = _c(15);
  const {
    email,
    className
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [isModalOpened, setIsModalOpened] = useState(false);
  const t1 = !email;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsModalOpened(true);
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t) {
    t3 = t("dashboard.email_statistics.preview_email_button_label");
    $[1] = t;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = <span>{t3}</span>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t1 || $[6] !== t4) {
    t5 = <PrimaryButton isFetching={t1} onClick={t2}>{t4}</PrimaryButton>;
    $[5] = t1;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== email || $[9] !== isModalOpened) {
    t6 = email && <EmailPreviewModal preview={email.useNewEditor ? email.html ?? "" : email.body ?? ""} subject={email.subject} opened={isModalOpened} onClose={() => setIsModalOpened(false)} />;
    $[8] = email;
    $[9] = isModalOpened;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== className || $[12] !== t5 || $[13] !== t6) {
    t7 = <div className={className}>{t5}{t6}</div>;
    $[11] = className;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};